import * as types from './action-types';

import { defineAction } from 'store/common/action-helpers';

export const fetchCompanyAdvisorConnectionsForAdminByPrettyId = {
  request: ({ prettyId }) =>
    defineAction(types.FETCH_COMPANY_ADVISOR_CONNECTIONS_FOR_ADMIN_BY_PRETTY_ID.REQUEST, {
      prettyId,
    }),
  start: ({ prettyId }) =>
    defineAction(types.FETCH_COMPANY_ADVISOR_CONNECTIONS_FOR_ADMIN_BY_PRETTY_ID.START, {
      prettyId,
    }),
  success: ({ prettyId }) =>
    defineAction(types.FETCH_COMPANY_ADVISOR_CONNECTIONS_FOR_ADMIN_BY_PRETTY_ID.SUCCESS, {
      prettyId,
    }),
  failure: ({ prettyId, error }) =>
    defineAction(types.FETCH_COMPANY_ADVISOR_CONNECTIONS_FOR_ADMIN_BY_PRETTY_ID.FAILURE, {
      prettyId,
      error,
    }),
};

export const inviteAdvisorToCompany = {
  request: (values, form, modal) =>
    defineAction(types.INVITE_ADVISOR_TO_COMPANY.REQUEST, values, { form, modal }),
  start: values => defineAction(types.INVITE_ADVISOR_TO_COMPANY.START, values),
  success: ({ advisorConnection, prettyId }) =>
    defineAction(types.INVITE_ADVISOR_TO_COMPANY.SUCCESS, {
      advisorConnection,
      prettyId,
    }),
  failure: ({ email, prettyId, error }) =>
    defineAction(types.INVITE_ADVISOR_TO_COMPANY.FAILURE, {
      email,
      prettyId,
      error,
    }),
};

export const updateAdvisorToCompany = {
  request: (values, form, modal) =>
    defineAction(types.UPDATE_ADVISOR_TO_COMPANY.REQUEST, values, { form, modal }),
  start: values => defineAction(types.UPDATE_ADVISOR_TO_COMPANY.START, values),
  success: ({ advisorConnection, prettyId }) =>
    defineAction(types.UPDATE_ADVISOR_TO_COMPANY.SUCCESS, {
      advisorConnection,
      prettyId,
    }),
  failure: ({ email, prettyId, error }) =>
    defineAction(types.UPDATE_ADVISOR_TO_COMPANY.FAILURE, {
      email,
      prettyId,
      error,
    }),
};

export const deleteAdvisorFromCompany = {
  request: ({ advisorId, prettyId }) =>
    defineAction(types.DELETE_ADVISOR_FROM_COMPANY.REQUEST, {
      advisorId,
      prettyId,
    }),
  start: ({ advisorId, prettyId }) =>
    defineAction(types.DELETE_ADVISOR_FROM_COMPANY.START, {
      advisorId,
      prettyId,
    }),
  success: ({ advisorId, prettyId }) =>
    defineAction(types.DELETE_ADVISOR_FROM_COMPANY.SUCCESS, {
      advisorId,
      prettyId,
    }),
  failure: ({ advisorId, prettyId, error }) =>
    defineAction(types.DELETE_ADVISOR_FROM_COMPANY.FAILURE, {
      advisorId,
      prettyId,
      error,
    }),
};

export const updateSoftConnectionStatus = {
  request: ({ advisorId, prettyId, status }) =>
    defineAction(types.UPDATE_SOFT_CONNECTION_STATUS.REQUEST, {
      advisorId,
      prettyId,
      status,
    }),
  start: ({ advisorId, prettyId }) =>
    defineAction(types.UPDATE_SOFT_CONNECTION_STATUS.START, {
      advisorId,
      prettyId,
    }),
  success: ({ advisorId, prettyId }) =>
    defineAction(types.UPDATE_SOFT_CONNECTION_STATUS.SUCCESS, {
      advisorId,
      prettyId,
    }),
  failure: ({ advisorId, prettyId, error }) =>
    defineAction(types.UPDATE_SOFT_CONNECTION_STATUS.FAILURE, {
      advisorId,
      prettyId,
      error,
    }),
};



// WEBPACK FOOTER //
// ./src/store/features/admin/companies/advisors/actions.js